import React, { useCallback } from 'react';

import { ReactComponent as BoonIcon } from '../../assets/images/boon-initial.svg';
import { ReactComponent as CSVIcon } from '../../assets/images/contact-csv.svg';
import { ReactComponent as GoogleIcon } from '../../assets/images/Google.svg';
import { ReactComponent as LinkedinIcon } from '../../assets/images/linkedin.svg';
import { ReactComponent as MicrosoftIcon } from '../../assets/images/microsoft.svg';
import { ReactComponent as VCFIcon } from '../../assets/images/VCFIcon.svg';

import styles from './ContactSources.module.scss';

const ContactSources = ({ sources }) => {
  const renderIcon = useCallback((value) => {
    if (value === 'google_people') {
      return <GoogleIcon />;
    }
    if (value === 'outlook') {
      return <MicrosoftIcon />;
    }
    if (value === 'linkedin') {
      return <LinkedinIcon />;
    }
    if (value === 'csv_import') {
      return <CSVIcon />;
    }
    if (value === 'manual') {
      return <BoonIcon />;
    }
    if (value === 'vcf_import') {
      return <VCFIcon />;
    }
  }, []);

  return (
    <div className={styles.sourcesCont}>
      {sources.map((value) => (
        <div className={styles.sourceCont} key={value}>
          {renderIcon(value)}
        </div>
      ))}
    </div>
  );
};

export default ContactSources;
